import { render, staticRenderFns } from "./Events-hero.vue?vue&type=template&id=076f697e&scoped=true&"
import script from "./Events-hero.vue?vue&type=script&lang=js&"
export * from "./Events-hero.vue?vue&type=script&lang=js&"
import style0 from "./Events-hero.vue?vue&type=style&index=0&id=076f697e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076f697e",
  null
  
)

export default component.exports